export const appStorage = {
  getItem: (key: 'context') => {
    const stringifiedData = localStorage.getItem(`${key}`);
    if (!stringifiedData) return '';
    return JSON.parse(stringifiedData || '');
  },
  setItem: (key: 'context', data: any) => {
    if (!data) return;
    localStorage.setItem(key, JSON.stringify(data));
  },
  removeItem: (key: 'context') => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },
};
